module.exports = __webpack_public_path__ + "media/images/geonobel-ab5b6e7207c9a97362dbedded473ef17.png";